import React from 'react'
import TableCell from '_zari/core/table/cell'
import TableRow from '_zari/core/table/row'

import { makeStyles, Table, TableBody, TablePagination } from '@material-ui/core'

import EnhancedTableHead from './tableHead'
import CuadroBusqueda from './cuadroBusqueda'

import { ReactComponent as EmptyPlato } from '_zari/images/svg/empty.svg'

const useStyles = makeStyles(() => ({
  tableWrapper: {
    overflowX: 'auto'
  }
}))

const EmptyTableRow = ({ colSpan }) => {
  return (
    <TableRow style={{ height: 290 }}>
      <TableCell colSpan={colSpan} align='center'>
        <EmptyPlato height='70' width='70' style={{ color: '#acacac', fill: 'currentColor' }} />
        <p
          style={{
            margin: '0',
            padding: '0',
            fontSize: '1.2rem',
            color: '#a8a8a8',
            marginTop: '10px',
            fontWeight: '200'
          }}
        >
          La tabla no contiene registros.
        </p>
      </TableCell>
    </TableRow>
  )
}

const EnhancedTable = props => {
  const classes = useStyles()

  const handleChangePage = (_, newPage) => {
    props.handleChangePage(newPage)
  }

  const filasNulas = React.useMemo(() => {
    return props.filasPorPagina - props.filas.length
  }, [props])

  const emptynessDisplay = React.useMemo(() => {
    if (filasNulas === 10) {
      return <EmptyTableRow colSpan={props.headRows.length} />
    } else if (filasNulas > 0) {
      return (
        <TableRow style={{ height: 29 * filasNulas }}>
          <TableCell colSpan={props.headRows.length} />
        </TableRow>
      )
    } else {
      return <></>
    }
  }, [props, filasNulas])

  return (
    <>
      {props.showSearchBox && <CuadroBusqueda onChange={props.handleBusquedaChange} />}
      <div className={classes.tableWrapper}>
        <Table aria-labelledby='tableTitle' size='small' className='zr-table'>
          <EnhancedTableHead headRows={props.headRows} useFilters={props.useFilters} tableId={props.id} onFilterChange={props.onFilterChange} />
          <TableBody className='zr-tbody'>
            {props.filas.map(props.rowTemplate)}
            {emptynessDisplay}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        rowsPerPageOptions={[]}
        component='div'
        count={props.totalRows}
        rowsPerPage={props.filasPorPagina}
        page={props.currentPage}
        backIconButtonProps={{
          'aria-label': 'Previous Page'
        }}
        nextIconButtonProps={{
          'aria-label': 'Next Page'
        }}
        onChangePage={handleChangePage}
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count <= 500 ? count : `más de ${to}`}`}
      />
    </>
  )
}

export default EnhancedTable
